import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  formLabel: {
    color: "#3a3a3a",
    textAlign: 'left',
    marginBottom: '8px'
  },
});
